import { getRootReducer } from './reducers.main';
import { createStore, compose, applyMiddleware } from "redux";
import {thunk} from './services/redux-middleware';
import {APICallMiddleware} from './services/ApiMiddleware';
import {ISDEVELOP} from './globals.js';

let store;
export const getStore = () => {
    if (!store) {
        const reducers = getRootReducer();
        store = configureStore(reducers);
    }
    return store;
};


function configureStore (rootReducer) {

    const composeFn = (ISDEVELOP && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||  compose;
    const composeArgs = [
        applyMiddleware(
            APICallMiddleware,
            thunk,
        )
    ];

    const store = createStore(
        rootReducer,
        composeFn.apply(this, composeArgs)
    );

    return store;
}
